const azureUrls = ['ads.microsoft.com', 'ads-int.microsoft.com'];
const isAzureEnv = ({ hostname, protocol }) => protocol.toLowerCase().indexOf('https') === 0 &&
azureUrls.some(url => hostname.toLowerCase().indexOf(url) > -1);

export function getODataPath(location) {
  return isAzureEnv(location) ? 'Campaign/V2' : 'Advertiser/V2';
}

export function getConfig() {
  return {
    odataPath: getODataPath(window.location),
  };
}
